/** @graphql cc **/

import gql from 'graphql-tag';

import { type Extension } from '@atlassian/forge-ui';

import { query } from '@confluence/query-preloader-tools';

import type { ConfluenceForgeExtensionsByTypeResponse } from '../__types__/confluence_forgeExtensionsByType';

type FetchForgeAppsProps = {
	cloudId: string;
	locale: string;
	types: string[];
	context: { spaceId: string } | null;
	includeHidden: boolean;
};

export const fetchForgeApps = async ({
	cloudId,
	locale,
	types,
	context,
	includeHidden,
}: FetchForgeAppsProps): Promise<Extension[] | null> => {
	const { data } = await query<
		ConfluenceForgeExtensionsByTypeResponse['data'],
		FetchForgeAppsProps
	>({
		query: gql`
			query fetchForgeAppsQuery(
				$cloudId: ID!
				$context: ConfluenceExtensionRenderingContextInput
				$includeHidden: Boolean
				$locale: String
				$types: [String]
			) {
				confluence_forgeExtensionsByType(
					cloudId: $cloudId
					context: $context
					includeHidden: $includeHidden
					locale: $locale
					types: $types
				) {
					id
					appVersion
					environmentType
					environmentKey
					properties {
						key
						value
					}
					type
					installationId
				}
			}
		`,
		variables: {
			cloudId,
			locale,
			types,
			context,
			includeHidden,
		},
	});

	return transformForgeApps(data);
};

const transformForgeApps = (
	data: ConfluenceForgeExtensionsByTypeResponse['data'] | null,
): Extension[] | null => {
	if (!data) {
		return null;
	}

	return data.confluence_forgeExtensionsByType.map(
		(extension): Extension => ({
			id: extension.id,
			appId: undefined, // TODO - CCBOREALIS-8078: add missing properties
			appVersion: extension.appVersion ?? undefined,
			environmentId: '', // TODO - CCBOREALIS-8078: add missing properties
			environmentType: extension.environmentType,
			environmentKey: extension.environmentKey,
			properties: extension.properties.reduce((acc, property) => {
				acc[property.key] = property.value;
				return acc;
			}, {}),
			// license: extension.license, // TODO - CCBOREALIS-8078: add missing properties
			// userAccess: extension.userAccess, // TODO - CCBOREALIS-8078: add missing properties
			type: extension.type,
			installationId: extension.installationId,
			dataClassificationPolicyDecision: {
				status: 'ALLOWED',
			},
		}),
	);
};
